import connectExtras from './ProgressBarExtrasContainer';
import _ProgressBarExtras from './ProgressBarExtras';
import _ProgressBarExtrasMobile from './ProgressBarExtrasMobile';

export const ProgressBarExtras = connectExtras(_ProgressBarExtras);
export const ProgressBarExtrasMobile = connectExtras(_ProgressBarExtrasMobile);
